// $(document).ready(function () {
//     scrollTopBtn = $('.scrollTopBtn');
//     $(window).scroll(checkScrollBtn)
//     checkScrollBtn();
// });

// function checkScrollBtn() {
//     if ($(window).scrollTop() > scrollBtnBorder && !showScrollBtn) {
//         showScrollBtn = true;
//         scrollTopBtn.fadeIn(animationTime);
//     };
//     if ($(window).scrollTop() <= scrollBtnBorder && showScrollBtn) {
//         showScrollBtn = false;
//         scrollTopBtn.fadeOut(animationTime);
//     };
// };